import { render } from "./ModernDashboardView.vue?vue&type=template&id=cd8e8f0a&scoped=true"
import script from "./ModernDashboardView.vue?vue&type=script&lang=js"
export * from "./ModernDashboardView.vue?vue&type=script&lang=js"

import "./ModernDashboardView.vue?vue&type=style&index=0&id=cd8e8f0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd8e8f0a"]])

export default __exports__